import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DcpGlobalMessageComponent} from './global-message.component';
import {ConfigModule, I18nModule} from '@spartacus/core';

@NgModule({
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        GlobalMessageComponent: {
          component: DcpGlobalMessageComponent,
        },
      },
    }),
    I18nModule,
    DcpGlobalMessageComponent,
  ],
  exports: [DcpGlobalMessageComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DcpGlobalMessageComponentModule {}
